<form (ngSubmit)="completeStop()" [formGroup]="form">
	<h1 mat-dialog-title>{{'completeRouteStopView.title' | translate}}</h1>
	<mat-dialog-content>
		<div fxLayout="column" fxLayoutAlign="start">
			<mat-form-field fxFlex>
				<mat-label>{{'completeRouteStopView.podNamePlaceholder' | translate}}</mat-label>
				<input formControlName="name" matInput required type="text"/>
				<mat-error>{{'completeRouteStopView.podNamePlaceholder' | translate}} is required</mat-error>
			</mat-form-field>
			<mat-form-field fxFlex>
				<mat-label>Completed Date</mat-label>
				<input [matDatepicker]="picker" formControlName="completedDate" matInput placeholder="YYYY-MM-DD"
					   required>
				<mat-error>Please enter a valid date</mat-error>
				<mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
				<mat-datepicker #picker></mat-datepicker>
			</mat-form-field>
			<mat-form-field fxFlex>
				<mat-label>Select a time</mat-label>
				<input [format]="24" [ngxTimepicker]="completedTime" formControlName="completedTime" matInput
					   placeholder="hh:mm" readonly required>
				<mat-error>Please enter a valid time</mat-error>
				<ngx-material-timepicker
					#completedTime
					[enableKeyboardInput]="true"
					(timeChanged)="onTimeSet($event)"></ngx-material-timepicker>
			</mat-form-field>
		</div>
	</mat-dialog-content>
	<mat-dialog-actions fxLayout="row" fxLayoutAlign="end" fxLayoutGap="5px">
		<button [color]="'accent'" mat-dialog-close mat-raised-button type="button">
			{{'completeRouteStopView.closeButton' | translate}}
		</button>
		<button [color]="'primary'" mat-raised-button type="submit">
			{{'completeRouteStopView.completeButton' | translate}}
		</button>
	</mat-dialog-actions>
</form>
